import intlTelInput from "intl-tel-input";

interface IintlTelInputFunc {
  setDialCode: React.Dispatch<React.SetStateAction<string>>;
  input: Element;
}

const utilsScriptUrl =
  "https://cdn.jsdelivr.net/npm/intl-tel-input/build/js/utils.js";

export const intlTelInputFunc = ({ setDialCode, input }: IintlTelInputFunc) => {
  const iti = intlTelInput(input as HTMLInputElement, {
    initialCountry: "auto",
    separateDialCode: false,
    autoPlaceholder: "aggressive", // polite, off
    strictMode: true,
    geoIpLookup: (callback) => {
      fetch("https://ipinfo.io/json") // https://ipapi.co/json
        .then((res) => res.json())
        .then((data) => callback(data.country)) // country_code
        .catch(() => callback("us"));
    },
    loadUtilsOnInit: utilsScriptUrl,
  });

  input.addEventListener("countrychange", () => {
    const { dialCode } = iti.getSelectedCountryData();
    // const selectedCountry = iti.getSelectedCountryData();
    // const countryCode = selectedCountry.iso2;
    setDialCode(dialCode as string);
    // setCountryCode(countryCode as string);
  });
};
